import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Button } from '@/components/atoms/Buttons';
import { Overline } from '@/components/atoms/Eyebrow';

import type { BlockSortKey, SortDirection } from '../../helpers/lineageBlocks';

import styles from './ColumnHeader.module.scss';

export interface BlockSort {
    key: BlockSortKey;
    direction: SortDirection;
}

const COLUMNS = [
    { key: 'name', label: 'board.columns.fishGroup' },
    { key: 'pen', label: 'board.columns.pen' },
] as const;

interface ColumnHeaderProps {
    sort: BlockSort;
    onSort: (key: BlockSortKey) => void;
}

/** The label column's heading: sorts the board by fish group or by pen. */
export default function ColumnHeader(props: ColumnHeaderProps) {
    const { sort, onSort } = props;
    const { t } = useTranslation('fishGroups');

    return (
        <div className={styles.columns}>
            {COLUMNS.map((column) => {
                const active = sort.key === column.key;
                const label = t(column.label);
                return (
                    <Button
                        key={column.key}
                        variant="link"
                        className={styles.sort}
                        aria-label={
                            active
                                ? t(
                                      sort.direction === 'asc'
                                          ? 'board.sort.ascending'
                                          : 'board.sort.descending',
                                      { column: label }
                                  )
                                : t('board.sort.sortBy', { column: label })
                        }
                        onClick={() => onSort(column.key)}>
                        <Overline
                            className={classNames(styles.label, { [styles.labelActive]: active })}>
                            {label}
                            {active && (
                                <span aria-hidden="true">
                                    {sort.direction === 'asc' ? ' ↑' : ' ↓'}
                                </span>
                            )}
                        </Overline>
                    </Button>
                );
            })}
        </div>
    );
}
